// reducer.js
import {
  FETCH_REFERRAL_SUCCESS,
  FETCH_REFERRAL_FAILURE,
  FETCH_REFERRAL_REQUEST,
} from "../../actionTypes";

const initialState = {
  data: {},
  status: false,
  isLoading: false,
  message: "",
};

const referralRecruiterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFERRAL_REQUEST:
      console.log("Referral data received:", action.payload);
      return {
        ...state,
        isLoading: true,
      };

    case FETCH_REFERRAL_SUCCESS:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        data: action.payload.data,
      };
    case FETCH_REFERRAL_FAILURE:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default referralRecruiterReducer;
